import {
  PROJECT_REPORT_PERIOD_LABELS,
  PROJECT_REPORT_STATUS_LABELS,
} from '@/constants/project-report';
import type { ProjectReportRecord } from '@/types/project-report';
import { formatProjectReportDate } from '@/utils/format-date';

interface MobileProjectReportCardProps {
  report: ProjectReportRecord;
  onClick?: () => void;
}

export function MobileProjectReportCard({ report, onClick }: MobileProjectReportCardProps) {
  return (
    <button type="button" className="mobile-card mobile-card--clickable" onClick={onClick}>
      <div className="mobile-card__header">
        <span className="mobile-card__title">
          {PROJECT_REPORT_PERIOD_LABELS[report.reportPeriod]} ·{' '}
          {formatProjectReportDate(report.reportDate, report.createdAt, report.reportPeriod)}
        </span>
        <span className="mobile-tag">{PROJECT_REPORT_STATUS_LABELS[report.status]}</span>
      </div>
      <div className="mobile-card__meta">填报人：{report.createdBy.name}</div>
      <p className="mobile-card__summary">{report.progressContent}</p>
    </button>
  );
}
